<template>
  <div class="more-info-right">
    <div class="row">
      <div class="col col-12" v-if="$route.name !== 'payment'">
        <button
          class="btn btn-primary"
          @click="book"
        >{{ currency }}{{ parseFloat(moreInfo.price).toFixed(2) }} {{ $t('more_info.book_now') }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <ul>
          <li v-if="moreInfo.on_airport == 1 && moreInfo.park_type != 'Chauffeur'">
            <h3 class="title">{{ $t('more_info.right.on_airport') }}</h3>
            <p> {{ $t('more_info.right.walking_distance') }}</p>
          </li>
          <li v-if="moreInfo.on_airport != 1 && moreInfo.park_type != 'Chauffeur'">
            <h3 class="title">{{ moreInfo.park_type }}</h3>
          </li>
          <li v-if="moreInfo.on_airport != 1 && moreInfo.park_type != 'Chauffeur'">
            <h3 class="title">{{ moreInfo.transfer_time }} {{ $t('more_info.right.min') }}</h3>
            <p>{{ $t('more_info.right.transfer_time') }}</p>
          </li>
          <li v-if="moreInfo.park_type == 'Chauffeur'">
            <h3 class="title">{{ $t('more_info.right.meet_greet') }}</h3>
            <p>{{ $t('more_info.right.met_terminal') }}</p>
          </li>
          <li v-if="moreInfo.park_type != 'Chauffeur' && moreInfo.distance_from_airport > 0">
            <h3 class="title">
              {{ moreInfo.distance_from_airport || 0 }} {{ moreInfo.distance_from_airport == 1 ? distanceUnit.replace('s', '') : distanceUnit }}
            </h3>
            <p> {{ $t('more_info.right.distance_airport') }}</p>
        </li>
        </ul>
      </div>
    </div>
    <div class="row park_mark" v-if="moreInfo.park_mark_award === '1'">
      <div class="col col-12">
        <img :src="`${cdn}/images/image60.png`" :alt="$t('airportparking.results.product.park_mark')" />
      </div>
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import { eventBus } from "@/eventBus";
import mixins from "@/mixins";

export default {
  name: "RightCol",
  mixins: [mixins.format, mixins.globals],
  computed: {
    moreInfo: sync("modals/moreInfo")
  },
  methods: {
    book() {
      eventBus.$emit("SELECTED", this.moreInfo);
    }
  }
};
</script>